export const STAFF = 'Staff'
export const OSR = 'Outside Sales Rep'
export const CLIENT = 'Client'
export const TEAM = 'Team Member'
export const MANAGER = 'Manager'
